import { render, staticRenderFns } from "./TeamInvitationSuccess.vue?vue&type=template&id=9c296016&"
import script from "./TeamInvitationSuccess.vue?vue&type=script&lang=js&"
export * from "./TeamInvitationSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports